module.exports = __webpack_public_path__ + "img/金烽客流分析系统V1.O(3).917adace.png";